const moduleNameKey = "staticSeparator";

export const staticSeparatorEn = {
  [moduleNameKey]: {
    fontColorLabel: "Font color",
    transparentLabel: "Transparent background",
    saveButton: "Save",
    cancelButton: "Cancel",
  },
};

export const staticSeparatorPtBr = {
  [moduleNameKey]: {
    fontColorLabel: "Cor da fonte",
    transparentLabel: "Fundo transparente",
    saveButton: "Salvar",
    cancelButton: "Cancelar",
  },
};

export const staticSeparatorDe = {
  [moduleNameKey]: {
    fontColorLabel: "Schriftfarbe",
    transparentLabel: "Transparenter Hintergrund",
    saveButton: "Speichern",
    cancelButton: "Abbrechen",
  },
};

export const staticSeparatorZhHans = {
  [moduleNameKey]: {
    fontColorLabel: "字体颜色",
    transparentLabel: "透明背景",
    saveButton: "保存",
    cancelButton: "取消",
  },
};

export const staticSeparatorIt = {
  [moduleNameKey]: {
    fontColorLabel: "Colore testo",
    transparentLabel: "Sfondo trasparente",
    saveButton: "Salva",
    cancelButton: "Annulla",
  },
};

export const staticSeparatorEs = {
  [moduleNameKey]: {
    fontColorLabel: "Color de fuente",
    transparentLabel: "Fondo transparente",
    saveButton: "Guardar",
    cancelButton: "Cancelar",
  },
};

export const staticSeparatorNl = {
  [moduleNameKey]: {
    fontColorLabel: "Tekstkleur",
    transparentLabel: "Transparante achtergrond",
    saveButton: "Opslaan",
    cancelButton: "Annuleren",
  },
};

export const staticSeparatorTr = {
  [moduleNameKey]: {
    fontColorLabel: "Yazı tipi rengi",
    transparentLabel: "Saydam arka plan",
    saveButton: "Kaydetmek",
    cancelButton: "İptal etmek",
  },
};
